import { RefObject } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

let installed = false;

type ScrollOptions = Pick<ScrollToOptions, 'top' | 'left'>;

export const scroll = (options: ScrollOptions): void => {
  if (!installed) {
    try {
      smoothscroll.polyfill();
    } catch (err) {
      console.error(`smoothscroll polyfill failed`, err);
      return;
    }

    installed = true;
  }

  try {
    window.scroll({ behavior: `smooth`, ...options });
  } catch (err) {
    console.error(`smoothscroll polyfill failed`, err);
  }
};

export const scrollTo = (el: RefObject<HTMLDivElement>, offset = 0): void => {
  if (el.current) {
    scroll({
      top: el.current.offsetTop + offset,
    });
  }
};
